// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default } from "./Tab";
export * from "./TabContext";
export * from "./utils";
